// extracted by mini-css-extract-plugin
module.exports = {"itemList":"FAQ_itemList__qfvrW","itemId":"FAQ_itemId__WNTtE","page":"FAQ_page__ghQP_","question":"FAQ_question__oKQrK","updated":"FAQ_updated__YAooY"};